import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TInvoiceRegisterListGetReq,
  TInvoiceRegisterListGetRes,
  TInvoiceKoteiSeikyuListGetReq,
  TInvoiceKoteiSeikyuListGetRes,
  TInvoiceRegisterListPutReq,
  TInvoiceKoteiSeikyuListPutReq,
  TInvoiceRegisterListPutRes,
} from "./TInvoice"

/**
 * 請求明細一覧画面に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class InvoiceListService extends ConnectApi {
  /**
   * 請求明細一覧取得
   *
   * @param {TInvoiceRegisterListGetReq} params
   * @param {(param: TApiResponse<TInvoiceRegisterListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TInvoiceRegisterListGetRes[]]>) => any} reject
   * @memberof invoiceListService
   */
  getList = async (
    params: TInvoiceRegisterListGetReq,
    resolve?: (param: TApiResponse<TInvoiceRegisterListGetRes[]>) => any,
    reject?: (
      param: TApiResponse<TInvoiceRegisterListGetRes[]> | undefined
    ) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TInvoiceRegisterListGetRes[]>> =
        await this.getInner(`/billing/seikyumeisai`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TInvoiceRegisterListGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 固定請求明細一覧取得
   *
   * @param {TInvoiceKoteiSeikyuListGetReq} params
   * @param {(param: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]]>) => any} reject
   * @memberof invoiceListService
   */
  getKoteiSeikyuList = async (
    params: TInvoiceKoteiSeikyuListGetReq,
    resolve?: (param: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>) => any,
    reject?: (
      param: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]> | undefined
    ) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>> =
        await this.getInner(`/billing/koteiseikyumeisai`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 請求明細一覧更新
   *
   * @param {TInvoiceRegisterListPutReq} data
   * @param {(param: TApiResponse<TInvoiceRegisterListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TInvoiceRegisterListGetRes>>) => any} reject
   * @memberof invoiceListService
   */
  put = async (id: number, data: TInvoiceRegisterListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TInvoiceRegisterListPutRes>> =
        await this.putInner(`/billing/seikyumeisai/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 固定請求明細一覧更新
   *
   * @param {TInvoiceKoteiSeikyuListPutReq} data
   * @param {(param: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TInvoiceKoteiSeikyuListGetRes[]>) => any} reject
   * @memberof invoiceListService
   */
  putKoteiSeikyu = async (id: number, data: TInvoiceKoteiSeikyuListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>> =
        await this.putInner(`/billing/koteiseikyumeisai/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
